import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import Notiflix from "notiflix";

import {
  Input,
  Row,
  Card,
  Form,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Layout,
  Collapse,
  Button,
} from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import CustomButton from "../../../components/custom/CustomButton";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../systemAdmin.config";
import dayjs from "dayjs";

const { TextArea } = Input;
const { Content } = Layout;
const { Panel } = Collapse;

const DetailVaultConfig = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const { Text, Title } = Typography;
  const [officeData, setOfficeData] = useState([]);
  const [glAccountData, setGLAccountData] = useState([]);
  const [current, setCurrent] = useState(0);
  const [configureLimitTableSource, setConfigurelimitTableSource] = useState(
    []
  );
  const [codeList, setCodeList] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  // ENDPOINT DECLARED VARIABLES
  const [formData, setFormData] = useState({
    authForm: null,
    vaultGl: null,
    tillGl: null,
  });

  useEffect(() => {
    // getProductTemplate(state);
    getOffices();
    getGLAccounts();
    getBranchValutById();
  }, []);

  const getOffices = () => {
    setIsLoading(true);

    const url = apiConfig.Offices;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        // setTemplateConfigDetail(res);
        const objDetails = res;
        let tempOfficeData = [];

        objDetails?.forEach((element) => {
          tempOfficeData.push({
            value: element.id,
            label: element.name,
          });
        });

        setOfficeData(tempOfficeData);

        setIsLoading(false);
      }
    });
  };

  const getGLAccounts = () => {
    setIsLoading(true);

    const url = apiConfig.GLAccounts;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetails = res;
        let tempGLAccountData = [];

        objDetails?.forEach((element) => {
          tempGLAccountData.push({
            value: element.id,
            label: element.name,
          });
        });

        setGLAccountData(tempGLAccountData);

        setIsLoading(false);
      }
    });
  };

  const getBranchValutById = () => {
    const url = `${apiConfig.VaultConfig + "/" + state.id}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;

        form.setFieldsValue({
          authForm: objList.operationId2,
          branchCcyRestrConfs: objList.branchCcyRestrConfs,
          branchOperationTransactionType:
            objList.branchOperationTransactionType,
        });

        setFormData({
        authForm: objList.operationId2,
        vaultGl: objList.vaultGl,
        tillGl: objList.tillGl,
      });

      setConfigurelimitTableSource(objList.vaultCcyRestrConfData)

        setCodeList(objList);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };


  const data = {
    authForm: [
      {
        name: "Branch",
        value: formData?.authForm?.officeId.name
      },
      {
        name: "Vault GL",
        value: formData?.vaultGl?.name
      },
      {
        name: "Till GL",
        value: formData?.tillGl?.name
      },
    ],
  };

  const columns = [
    [
      {
        key: " 1",
        title: "Vault Currency",
        dataIndex: "currencyCode",
      },
      {
        key: " 2",
        title: "	Maximium Vault Limit",
        dataIndex: "vaultMaxAmount",
      },
    ],
  ];

  function onCancel() {
    navigate("/sya0500", { state: state });
  }

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.detailVaultConfiguration}
        pageItems={staticConfig.detailVaultConfigurationBreadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                    fontSize: 15,
                  }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Card
            style={{
              marginBottom: "2%",
              boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            }}
          >
            {/* AUTH FORM  */}
            <div
              style={{
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                marginBottom: 25,
              }}
            >
              <Divider orientation="left" orientationMargin="0">
                {"Vault Configuration Info"}
              </Divider>
              {data.authForm.map((detail, index) => {
                // console.log("detail", detail);

                const { name, value } = detail;

                return (
                  <div
                    style={{
                      border: "2px solid #F5F5F5",
                      borderRadius: 15,
                      borderBottomLeftRadius: 0,
                      borderBottomRightRadius: 0,
                      borderBottomColor: "#E2E2E2",
                    }}
                    key={index}
                  >
                    <Row>
                      <Col
                        span={12}
                        style={{
                          backgroundColor: "#F5F5F5",
                          padding: 10,
                          borderRadius: 15,
                          borderTopRightRadius: 0,
                          borderBottomRightRadius: 0,
                          borderBottomLeftRadius: 0,
                        }}
                      >
                        <Text strong>{name}</Text>
                      </Col>
                      <Col
                        span={12}
                        style={{
                          padding: 10,
                        }}
                      >
                        <Text className="of-bold-disable-input">{value}</Text>
                      </Col>
                    </Row>
                  </div>
                );
              })}
            </div>

            {/* LIMITS FORM */}
            <div
              style={{
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                marginBottom: 25,
              }}
            >
              <Divider orientation="left" orientationMargin="0">
                {"Vault Currencies"}
              </Divider>
              <Table
                pagination={false}
                columns={columns[0]}
                dataSource={configureLimitTableSource}
              />
            </div>
          </Card>
        </Card>
      </Spin>
    </MainLayout>
  );
};
export default DetailVaultConfig;
